import { createContext, useContext } from "react";

// Token context - defined here, provider in TokenProvider.jsx
export const TokenContext = createContext({
    token: "",
    setToken: () => {},
    clearToken: () => {},
    tokenLoading: false,
    localStorageAvailable: true,
    impersonationToken: "",
    setImpersonationToken: () => {},
    clearImpersonationToken: () => {},
    impersonationMetadata: null,
});

export const useToken = () => {
    const context = useContext(TokenContext);
    if (!context) {
        throw new Error("useToken must be used within a TokenProvider");
    }
    return context;
};

// User context - defined here, provider in UserContext.jsx
export const UserContext = createContext({
    token: null,
    userData: null,
    preferences: {}
});

export const useUser = () => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error("useUser must be used within a UserProvider");
    }
    return context;
};

// Shop context - defined here, provider in ShopContext.jsx
export const ShopContext = createContext();

export const useShop = () => {
    const context = useContext(ShopContext);
    if (!context) {
        throw new Error("useShop must be used within ShopProvider");
    }
    return context;
};

// Tournament context - defined here, provider in TournamentContext.jsx
export const TournamentContext = createContext();

export const useTournament = () => {
    const context = useContext(TournamentContext);
    if (!context) {
        throw new Error("useTournament must be used within a TournamentProvider");
    }
    return context;
};
